import React from 'react';
import './info-block-2.scss'
import {useTranslation} from "react-i18next";

function InfoBlock2() {
    const { t } = useTranslation()
    return <div id="info" className="info-block-2">
        <div className="info-block-2__wrapper">
            <h3 className="info-block-2__title title" data-aos="fade-down">{t('info_block_4.title')}</h3>

            <div className="info-block-2__text" data-aos="zoom-in">
                <p>{t('info_block_4.text1')}
                    <u>{t('info_block_4.text2')}</u>{t('info_block_4.text3')}</p>

                <p>{t('info_block_4.text4')}</p>
            </div>

            <button className="info-block-2__button button" data-aos="fade-up">{t('info_block_4.button')}</button>
        </div>
    </div>;
}

export default InfoBlock2;